/**
 * @generated SignedSource<<47e752aa053d72fcee732e5e0ee507ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionCompletePurchase_viewer$data = {
  readonly isMultiItemCart: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionActionCompletePurchase_viewer";
};
export type PdpSharedAuctionActionCompletePurchase_viewer$key = {
  readonly " $data"?: PdpSharedAuctionActionCompletePurchase_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionCompletePurchase_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionCompletePurchase_viewer",
  "selections": [
    {
      "alias": "isMultiItemCart",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "fff6c32c50a9f9f663aa391767539c51";

export default node;
